export default "__VITE_ASSET__BOfwr3N0__"